import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GerenciadorPrecos } from '../../../../@types/GerenciadorPrecos';
import { GerenciadorExpandedRowKeyState, selectorExpandedRowKey } from '../../../../reducers/gerenciadorPrecos/expandedRowKey';
import { selectorIsWholesaleEnabled } from '../../../../reducers/reducerIPA/channels';

type Option = GerenciadorPrecos.Table.ExpandedRowMenu;

const WHOLESALE_OPTION: Option = 'WHOLESALE';

/**
 * Remove as opções de linha expandida cujo canal está desabilitado na configuração do cliente.
 * Fonte única da regra: a linha e a altura reservada para ela nascem daqui.
 */
export const useVisibleExpandedRow = (): GerenciadorExpandedRowKeyState => {
  const expandedRowKey = useSelector(selectorExpandedRowKey);
  const isWholesaleEnabled = useSelector(selectorIsWholesaleEnabled);

  return useMemo(() => {
    if (isWholesaleEnabled) return expandedRowKey;

    return {
      ...expandedRowKey,
      options: expandedRowKey.options.filter(option => option !== WHOLESALE_OPTION),
    };
  }, [expandedRowKey, isWholesaleEnabled]);
};
